const danhSachQuyenNguoiDung = (state) => state.danhSachQuyenNguoiDung;
const danhSachChiTietNguoiDung = (state) => state.danhSachChiTietNguoiDung;
const danhSachPhanQuyenNguoiDung = (state) => state.danhSachPhanQuyenNguoiDung;
export default {
  danhSachQuyenNguoiDung,
  danhSachChiTietNguoiDung,
  danhSachPhanQuyenNguoiDung,
};
